'use client';

import { TrackedAnchor } from '@/components/ancher';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';

import { CtaButton } from '../components/cta-button';

const HERO_CTA_CLASS =
  'flex h-[40px] w-fit items-center justify-center rounded-[30px] bg-[#040435] px-[14px] text-[14px] font-semibold leading-4 tracking-[-0.128px] text-white focus-visible:ring-[#040435] md:h-[56px] md:rounded-[100px] md:px-8 md:text-[18px] md:leading-7 md:tracking-[-0.256px]';

const ORDER_PAGE_CLASS =
  'flex h-[40px] w-fit items-center justify-center rounded-[30px] bg-[#ff7767] px-[14px] text-[14px] font-semibold leading-4 tracking-[-0.128px] text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff7767] focus-visible:ring-offset-2 md:h-[56px] md:rounded-[100px] md:px-8 md:text-[18px] md:leading-7 md:tracking-[-0.256px]';

/**
 * 정적 링크 버튼. 초기 SSR HTML 에 즉시 노출된다.
 */
export function OrderPageButton() {
  return (
    <TrackedAnchor
      href="https://neo.3billion.io/info"
      label="neo-hero-order-page"
      position="main_cta"
      className={ORDER_PAGE_CLASS}
    >
      Order Page for Parents
    </TrackedAnchor>
  );
}

export function HeroContactCta({ label }: { label: string }) {
  const inquiryChatProps = useInquiryChat();

  return (
    <CtaButton
      label="contact-us"
      position={TRACKED_EVENT_POSITION.MAIN_HEADER}
      {...inquiryChatProps}
      className={HERO_CTA_CLASS}
    >
      {label}
    </CtaButton>
  );
}
